export default {
	LEADS: 'companies/:company_id/leads/',
	MARK_UNREAD: 'companies/:company_id/leads/mark-unread/',
	MARK_READ: 'companies/:company_id/leads/mark-read/',
	SEND_RESERVATION_LINK:'companies/:company_id/leads/send-reservation-link',
	SEND_RENTAL_LINK:'companies/:company_id/leads/send-rental-link',
}
